import { TableHeaderType } from "../types/TableHeaderType";

export const VmTemplateHeader: TableHeaderType[] = [
  {
    label: "Name",
    key: "name",
    id: "name",
    sortable: true,
  },
  {
    label: "Cloud Provisioner Template",
    key: "cloudProvisionerTemplateFile",
    id: "cloudProvisionerTemplateFile",
    sortable: true,
  },
  {
    label: "Cloud Environment",
    key: "environment",
    id: "environment",
    sortable: true,
  },
  {
    id: "creationDate",
    label: "Creation Date",
    sortable: true,
    key: "creationDate",
  },
  
];
